module.exports = __webpack_public_path__ + "img/translate-five.da037214.png";